import dayjs from 'libs/dayjs';
import { ESTADOS_CERRADOS } from 'api/dataRequests';

// Una solicitud cerrada (resuelta o rechazada) ya no tiene plazo corriendo,
// aunque su vence_at esté en el pasado. Mostrarla en rojo sería mentir.
export const estaCerrada = (estado) => ESTADOS_CERRADOS.includes(estado);

/**
 * Traduce vence_at + estado al plazo legal que hay que mostrar.
 *
 * Devuelve null si no hay fecha utilizable, para que el llamador muestre '—'.
 *   { fecha, dias, vencida, cerrada, urgente, texto }
 *   - dias: días calendario que faltan (negativo si ya pasó).
 *   - vencida: sólo si el plazo pasó Y la solicitud sigue abierta.
 *   - urgente: quedan 3 días o menos, todavía abierta.
 */
export const calcularPlazo = (solicitud) => {
  const venceAt = solicitud?.vence_at;
  if (!venceAt) return null;

  const fecha = dayjs(venceAt);
  if (!fecha.isValid()) return null;

  const cerrada = estaCerrada(solicitud?.estado);
  // Diferencia en días calendario, no en múltiplos de 24 h: para el plazo legal
  // lo que importa es el día, no la hora.
  const dias = fecha.startOf('day').diff(dayjs().startOf('day'), 'day');
  const vencida = !cerrada && dias < 0;
  const urgente = !cerrada && dias >= 0 && dias <= 3;

  let texto;
  if (cerrada) texto = null;
  else if (dias < 0) {
    const diasVencida = Math.abs(dias);
    texto = `Venció hace ${diasVencida} ${diasVencida === 1 ? 'día' : 'días'}`;
  } else if (dias === 0) texto = 'Vence hoy';
  else if (dias === 1) texto = 'Vence mañana';
  else texto = `Vence en ${dias} días`;

  return { fecha, dias, vencida, cerrada, urgente, texto };
};

// Color del plazo según el token del tema. Nunca hex hardcodeado.
export const colorPlazo = (plazo, token) => {
  if (!plazo || plazo.cerrada) return token.colorTextSecondary;
  if (plazo.vencida) return token.colorError;
  if (plazo.urgente) return token.colorWarning;
  return token.colorText;
};

export const formatearFecha = (valor, conHora = false) => {
  if (!valor) return '—';
  const d = dayjs(valor);
  if (!d.isValid()) return '—';
  return d.format(conHora ? 'DD-MM-YYYY HH:mm' : 'DD-MM-YYYY');
};
